<template>
    <div class="f space-x-0.25">
        <!-- Status -->
        <el-tag v-if="status.value"
                :type="status.mood"
                class="fs-0.7"
                size="mini"
                :effect="dark ? 'dark' : 'light'">
            {{ status.value }}
        </el-tag>

        <!-- Polygons count -->
        <task-polygon-stats v-if="withPolygons"
                            :value="polygonsCount"
                            :dark="dark"
                            size="mini"
                            with-finished-accepted
                            with-finished-not-accepted
                            with-all-tooltip />
    </div> 
</template>

<script>
import { getPolygonsCount } from '@/models/tasks'

import TaskPolygonStats from '@/components/tasks/TaskPolygonStats.vue'
import { labelAt } from '@/utils/date'

export default {
  components: {
    TaskPolygonStats
  },
  props: {
    task: { type: Object, default: null },
    dark: { type: Boolean, default: false },

    withPolygons: { type: Boolean, default: false }
  },
  computed: {
    status() {
      const { status, translated_result, data } = this.task || {}
      const { approved_at } = data || {}

      let { value, mood } = translated_result || {}

      approved_at && status === 'approved' && (value = `${value}: ${labelAt(approved_at, { withTime: false, withAlias: false })}`)
      mood === 'sad' && (mood = 'info')

      return { value, mood }
    },

    polygonsCount() {
      return getPolygonsCount(this.task)
    }
  }
}
</script>
